<template>
    <div>

        <div class="modal fade"
             id="store-tariff-modal"
             tabindex="-1"
             role="dialog"
             aria-labelledby="contactModal"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form v-on:submit.prevent="sendMessage"
                              novalidate
                              method="POST"
                              accept-charset="UTF-8"
                              id="store-tariff-form"
                              enctype="multipart/form-data"
                              class="container-fluid text-left text-black font-weight-normal">

                            <header class="d-flex align-items-center mb-4">
                                <!--<img src="/images/icons/familia.png" alt="" class="mb-2">-->
                                <h2 class="mb-4">{{ __('site.Print-tariff') }}</h2>
                            </header>

                            <div class="row p-4 px-md-9">
                                <div class="col-lg-12 col-xs-12 flex-first flex-sm-unordered">
                                    <fieldset class="row ">
                                        <div class="col-12 col-lg-12 form-group" style="min-width: 15rem;">
                                            <input
                                                    :placeholder="__('forms.Your-name')"
                                                    required="required"
                                                    name="first_name"
                                                    type="text"
                                                    class="form-control shadow border-0">
                                            <small
                                                    v-if="errors.first_name"
                                                    v-text="errors.first_name[0]"
                                                    class="text-danger">
                                            </small>
                                        </div>

                                        <div class="col-12 col-lg-12 form-group" style="min-width: 15rem;">
                                            <input
                                                    :placeholder="__('forms.Your-surname')"
                                                    required="required"
                                                    name="last_name"
                                                    type="text"
                                                    class="form-control shadow border-0">
                                            <small
                                                    v-if="errors.last_name"
                                                    v-text="errors.last_name[0]"
                                                    class="text-danger">
                                            </small>
                                        </div>
                                        <div class="col-12 col-lg-12 form-group" style="min-width: 15rem;">
                                            <input
                                                    :placeholder="__('forms.Your-dni')"
                                                    required="required"
                                                    name="client_document"
                                                    type="text"
                                                    class="form-control shadow border-0">
                                            <small
                                                    v-if="errors.client_document"
                                                    v-text="errors.client_document[0]"
                                                    class="text-danger">
                                            </small>
                                        </div>
                                        <div class="col-12 col-lg-12 form-group" style="min-width: 15rem;">
                                            <input
                                                    :placeholder="__('forms.Your-email')"
                                                    name="client_email"
                                                    type="text"
                                                    class="form-control shadow border-0">
                                            <small
                                                    v-if="errors.client_email"
                                                    v-text="errors.client_email[0]"
                                                    class="text-danger">
                                            </small>
                                        </div>
                                        <div class="col-12 col-lg-12 form-group" style="min-width: 15rem;">
                                            <input
                                                    :placeholder="__('forms.Your-phone-number')"
                                                    required="required"
                                                    name="client_phone"
                                                    type="text"
                                                    class="form-control shadow border-0">
                                            <small
                                                    v-if="errors.client_phone"
                                                    v-text="errors.client_phone[0]"
                                                    class="text-danger">
                                            </small>
                                        </div>
                                    </fieldset>
                                </div>

                                <div class="col-lg-12 col-xs-12 form-group" style="min-width: 15rem;">
                                    <label class="form-check-label">
                                        <input
                                                required="required"
                                                name="terms"
                                                type="checkbox"
                                                v-model="terms"
                                                class="form-check-input">
                                        <a href="/legal" target="_blank" class="text-xs">
                                            {{ __('forms.Accept-terms-and-conditions') }}
                                        </a>
                                        <br/>
                                        <small
                                                v-if="errors.terms"
                                                v-text="errors.terms[0]"
                                                class="text-danger">
                                        </small>
                                    </label>
                                </div>
                            </div>

                            <fieldset class="row flex-nowrap">
                                <div class="col-12 col-lg-12 text-right form-group text-center">
                                    <input
                                            type="submit"
                                            :disabled="isSubmit"
                                            :value="__('site.Send')"
                                            class="btn btn-outline-secondary cursor-pointer"
                                            required>
                                </div>
                            </fieldset>
                        </form>
                    </div>
                </div>
            </div>
        </div>


        <modal-alert @confirm="successSendForm = false" v-if="successSendForm">
            <span slot="header">{{ __('alerts.tariff-print.header') }}</span>
            <div>{{__('alerts.tariff-print.message')}}</div>
        </modal-alert>

    </div>
</template>

<script>
  export default {
    data: function () {
      return {
        isSubmit: false,
        successSendForm: false,
        errors: [],
        attachedJSON: {},
        terms: null
      }
    },

    mounted: function () {
      $('#app').on('click', '[data-form-tariff]', event => {
        event.preventDefault()
        $('#store-tariff-modal').modal('show')
      })

      bus.$on('attachJsonToContactDialog', (results) => {
        this.attachedJSON = results
      })
    },

    methods: {
      sendMessage: function (form) {
        this.isSubmit = true
        var form = form.target
        this.errors = {}
        let data = {
          first_name: form.first_name.value,
          last_name: form.last_name.value,
          client_email: form.client_email.value,
          client_phone: form.client_phone.value,
          client_document: form.client_document.value,
          terms: this.terms
        }

        if (Object.keys(this.attachedJSON).length) {
          data.tariff = this.attachedJSON.budget
        }

        this.$http.post('/api/tariff', data).then(
          response => {
            //ga("send", "event", "print", "enviar", null, 1);
            var link = document.createElement('a')
            link.download = 'Arancel Notarial.pdf'
            link.href = '/descargar-arancel-notarial/' + response.data.id
            link.click()

            $('#store-tariff-modal').modal('hide')
            this.successSendForm = true
            this.isSubmit = false
          },
          response => {
            // Error
            this.isSubmit = false
            this.errors = Object.assign({}, this.errors, response.response.data)
            //ga("send", "event", "appointment", "enviar", null, 0);
          }
        )
      }
    }
  }
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/StoreTariffDialog.vue